// extracted by mini-css-extract-plugin
export default {"image-wrapper":"style_image-wrapper__d3v5+"};